<template>
  <div>
    <FormBox title="盈诺签服务公告">
      <div class="agreement" ref="agreement" @scroll="scrollEvent">
        公告编号：YNQ-2020-005<br>
        发布日期：2020年5月25日<br>
        <br>
        尊敬的盈诺签用户：<br>
        为进一步提升服务质量、保障用户权益，现将平台功能优化及服务升级事项公告如下：<br>

        一、服务升级说明<br>
        合规性强化<br>
        根据《中华人民共和国电子签名法》及最新行业规范，平台已完成权威CA机构认证升级，确保所有电子合同具备法律效力，支持司法存证调取。<br>

        安全技术升级<br>

        新增国密SM2/SM3算法加密，文件传输与存储安全性达金融级标准；<br>

        实名认证系统对接公安部公民网络身份识别eID系统，身份核验精准度提升至99.99%。<br>

        多终端兼容<br>
        全面支持PC网页端、iOS/Android移动端、微信小程序等多平台签约，实现"一键发起，全端同步"。<br>

        二、新增功能上线<br>
        智能模板库<br>
        提供1000+行业合同模板（含劳动协议、购销合同、租赁协议等），支持用户自定义模板及条款智能纠错。<br>

        团队协作签批<br>
        新增多角色会签功能，支持跨部门、跨企业多方在线协同签署，流程状态实时追踪。<br>

        区块链存证服务<br>
        签约文件自动同步至司法区块链节点，生成唯一存证编号，可一键出具《电子签约存证报告》。<br>

        三、服务优化与用户权益<br>
        操作简化<br>

        新增身份证OCR识别、企业工商信息自动填充功能，缩短发起流程50%；<br>

        短信/邮件提醒服务免费升级，关键节点自动推送提醒。<br>

        售后服务承诺<br>

        7×12小时客服支持（热线：400-666-0717）；<br>

        电子签章法律咨询免费通道（平台在线客服入口）。<br>

        四、注意事项<br>
        请确保账号完成企业/个人实名认证后再发起签约；<br>

        合同签署前请仔细核对签署方信息及文件内容；<br>

        建议下载合同至本地并同步使用平台存证服务，双重备份保障权益。<br>

        五、联系我们<br>
        如有疑问，可通过以下方式咨询：<br>

        客服热线：400-666-0717（工作日9:00-21:00）<br>

        在线咨询：登录官网点击右下角"在线客服"<br>

        帮助中心：https://www.yingnuoqian.com<br>

        盈诺签将持续以技术赋能信任，感谢您的一路同行！<br>
        <br>
        盈诺签运营中心<br>
        2020年5月25日<br>
        （本公告最终解释权归盈诺签所有）<br><br><br>
      </div>
      <div style="height: 10px"></div>
      <el-checkbox :disabled="checkboxDisabled" v-model="checked"
      >我已阅读《盈诺签服务公告》
      </el-checkbox
      >
      <div style="height: 10px"></div>
      <div>
        <el-button
            :loading="loading"
            type="primary"
            style="width: 100%"
            class="login-btn"
            @click="submit"
        >确认开通
        </el-button
        >
      </div>
    </FormBox>
  </div>
</template>

<script>
import FormBox from "./components/form-box";

export default {
  components: {
    FormBox,
  },
  data() {
    return {
      checked: false,
      loading: false,
      checkboxDisabled: true,
    };
  },
  mounted() {
    console.log(this.$store.state.opening.gzcAdmin)
  },
  computed: {
    gzcInfo() {
      return this.$store.state.opening.gzcInfo;
    },
    gzcCertificates() {
      return {
        legalIdCardFront: this.$store.state.opening.gzcCertificates.legalIdCardFront || '',
        legalIdCardBack: this.$store.state.opening.gzcCertificates.legalIdCardBack || '',
        organizationRegImg: this.$store.state.opening.gzcCertificates.organizationRegImg || ''
      };
    },
    gzcAdmin() {
      return {
        mobile: this.$store.state.opening.gzcAdmin.mobile || '',
        name: this.$store.state.opening.gzcAdmin.name || '',
        card: this.$store.state.opening.gzcAdmin.card || '',
        pass: this.$store.state.opening.gzcAdmin.pass || '',
        email: this.$store.state.opening.gzcAdmin.email || ''
      };
    }
  },

  methods: {
    scrollEvent() {
      var h =
          this.$refs.agreement.scrollHeight -
          this.$refs.agreement.offsetHeight -
          this.$refs.agreement.scrollTop; // 滚动条距离底部的高度
      if (h < 10) {
        this.checkboxDisabled = false;
        this.scrollEvent = () => {
        };
      }
    },

    async submit() {
      if (!this.checked) {
        this.$message.info("请滑动到底部并勾选我已阅读");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "开通中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        const res1 = await this.gzcOpening();
        console.log(res1)
        if (res1.data.code !== "200") {
          await this.$alert('开通失败，请稍后重试！');
          loading.close();
          return;
        }

        const res2 = await this.$api.attestation();
        if (res2.data.code === '200') {
          await this.$alert(
              `系统开通成功，请负责人签署【盈诺签】认证协议后方可出具电子公证书。协议签署短信已发送至${this.gzcInfo.legalPersonName}${this.gzcInfo.legalPersonPhone}手机上。`,
              "提示",
              {
                confirmButtonText: "去登陆系统",
                callback: (_) => {
                  loading.close();
                  this.$router.push("/login");
                },
              }
          );
        } else {
          loading.close();
          return
        }
        loading.close();
      } catch (error) {
        console.error(error);
        loading.close();
      }
    },
    // 盈诺签账号及API服务开通
    async gzcOpening() {
      return this.$api.gzcOpening({
        mobile: this.gzcAdmin.mobile, //管理员手机
        name: this.gzcAdmin.name, //管理员姓名
        card: this.gzcAdmin.card, //管理员身份证号
        pass: this.gzcAdmin.pass, //密码
        email: this.gzcAdmin.email, //管理员邮箱
        gzcName: this.gzcInfo.gzcName, //公证处全称
        gzcCode: this.gzcInfo.gzcCode, //公证处统一信用代码
        legalPersonName: this.gzcInfo.legalPersonName, //负责人姓名
        legalPersonIdNo: this.gzcInfo.legalPersonIdNo, //负责人身份证号
        legalPersonPhone: this.gzcInfo.legalPersonPhone, //负责人手机号
        gzcEmail: this.gzcInfo.email, //邮箱
        legalIdCardFront: this.subBase64(this.gzcCertificates.legalIdCardFront), //负责人身份证正面
        legalIdCardBack: this.subBase64(this.gzcCertificates.legalIdCardBack), //负责人身份证背面
        organizationRegImg: this.subBase64(this.gzcCertificates.organizationRegImg)
      });
    },
    // 截取base64
    subBase64(base64String) {
      return base64String
          .replace(/data:image\/jpeg;base64,/, "")
          .replace(/data:image\/png;base64,/, "")
          .replace(/data:image\/jpg;base64,/, "")
          .replace(/data:image\/gif;base64,/, "");
    },
  },
};
</script>

<style lang='less' scoped>
.agreement {
  padding: 0 20px 10px;
  height: 500px;
  overflow: auto;
  font-size: 14px;
  color: #333;
  line-height: 24px;
}

.agreement::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.agreement::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: rgba(144, 147, 153, 0.3);
}

.agreement::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #ededed;
  display: none;
}

</style>